/*
 * @Description:统计页面
 * @Author: Aimee·Zhang
 * @Date: 2020-10-23 16:52:20
 * @LastEditors: Aimee·Zhang
 * @LastEditTime: 2022-01-26 14:34:39
 */
import axios from 'axios'
import store from "@/store"
import router from "@/router";
// axios 配置
axios.defaults.timeout = 5000;
axios.defaults.baseURL = Glod.BaseUrl
// axios.defaults.baseURL = 'http://vote.wh.cnskl.com/api/';//测试
// axios.defaults.baseURL = 'https://hls-vote.cnskl.com/api/';//欢乐颂正式
// axios.defaults.baseURL = 'http://cctv-vote.cnskl.com/api/';// 北京投票

const axiosConf = (config) => {
	// config.headers.Authorization = store.state.accessToken;
	config.headers.Authorization = localStorage.getItem('accessTokenA')
	config.headers.Accept = 'application/json';
	return config;
};

axios.interceptors.request.use(axiosConf, err => {
	return Promise.reject(err);
});

axios.interceptors.response.use(async (response) => {
	let data = {};
	let code = Number(response.data.status_code);

	if (response.headers.authorization) {
		await store.commit('login', response.headers.authorization);
		response.config.headers.Authorization = response.headers.authorization;
	}

	if (code === 401) {
		let callback = window.location.protocol + "//" + window.location.host
		location.href = response.data.message + callback
	} else if (code === 200) {
		data = response.data.data;
	} else if (code == 404) {
		return Promise.reject(response.data);
	} else {
		return Promise.reject(response.data);
	}
	return data;
}, (error) => {
	return Promise.reject(error.response.data);
});

export default axios;



// WEBPACK FOOTER //
// ./src/api/axios.js